/**
 * Affiliations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    prestations: [],
    prestation: {}
};

// Getters
const getters = {
    prestations: state => {
        return state.prestations
    },

    prestation: state => {
        return state.prestation
    }
};

// Actions
const actions = {
    getPrestations(context, payload) {
        function successCallback(response) {
            context.commit('getPrestationsHandler', { prestations: response.data.prestations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Prestation.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPrestation(context, payload) {
        function successCallback(response) {
            context.commit('getPrestationHandler', { prestation: response.data.prestation });
        }

        function errorCallback(error) {

            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Prestation.Get, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    createPrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'prestation', params: { prestation: response.data.prestation.slug } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Prestation.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updatePrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'prestation' });
            router.push({ name: 'prestation', params: { prestation: response.data.prestation.slug } });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Prestation.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deletePrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'prestation' });
            router.push({ name: 'prestations' });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Prestation.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getPrestationsHandler(state, { prestations }) {
        // Update affiliations state
        state.prestations = prestations;
    },

    getPrestationHandler(state, { prestation }) {
        // Update affiliation state
        state.prestation = prestation;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}